<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-4 lbl">
          <label>Pays :</label>
        </div>
        <div v-if="!libellesPaysLoading" class="col-4">
          <Dropdown
            v-model="pays"
            :options="paysLibelles"
            :showClear="true"
            :filter="true"
            optionValue="valeur"
            optionLabel="texte"
            scrollHeight="205px"/>
        </div>
        <div v-else class="col-4">
          <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
        </div>
      </div>
    </div>
  </div>
  <div class="row solid-line"/>
  <div class="row">
    <div class="col">
      <Button @click="rechercher"> Rechercher </Button>
    </div>
    <div class="col" >
      <Button @click="redirectionAjouterProvince"> Ajouter </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['rechercher'],
  data() {
    return {
      pays: null,
      paysLibelles: [],
      libellesPaysLoading: false
    }
  },
  mounted() {
    this.libellesPaysLoading = true;
    this.$store.dispatch("pilotage/rechercherTableValeurSansAscAction", 'Pays').then((res) => {
      this.paysLibelles = res.data;
      this.paysLibelles.sort(function (a, b) {
        if (a.texte < b.texte) {
          return -1;
        }
        if (a.texte > b.texte) {
          return 1;
        }
        return 0;
      });
      this.libellesPaysLoading = false;
    });
  },
  methods: {
    redirectionAjouterProvince() {
      this.$router.push({name: 'ajouterProvincePilotage'});
    },
    rechercher(){
      
      let libelleRecherche = {};
      libelleRecherche.valeur = this.pays;
      libelleRecherche.enfant = {};
      libelleRecherche.enfant.code = 'Province';

      this.$emit('rechercher', libelleRecherche);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  }
}
</script>
